import { CreditCard, CURRENCIES, ISSUERS, NETWORKS } from "@/data/schemas";
import { DEFAULT_VALUATIONS } from "@/data/valuations";
import { SortMethods, type Filters } from "@/server/api/routers/schemas";
import { create } from "zustand";

interface StoreType {
  data: CreditCard[];
  setData: (data: CreditCard[]) => void;
  filters: Filters;
  setFilters: (filters: Filters) => void;
}

export const DEFAULT_FORM_VALUES: Filters = {
  sortMethod: SortMethods.ByValue,
  name: "",
  issuers: Object.values(ISSUERS),
  networks: Object.values(NETWORKS),
  valuationMethod: "Default", // TODO: WHy does `VALUATION_METHODS` import break here?
  isMilitary: "No",
  businessOrPersonal: ["Business", "Personal"],
  currentUniversalCashbackCurrency: CURRENCIES.USD,
  currentUniversalCashback: 1,
  maximumSpend: undefined,
  minimumSpend: undefined,
  minimumAnnualFee: undefined,
  maximumAnnualFee: undefined,
  maximumMonthlySpend: undefined,
  showCardsThatCountTowards524: ["Yes", "No"],
  minimumValue: 0,
  minimumPercentOfHistoricalMax: "All",
  customValuations: DEFAULT_VALUATIONS,
  travelOrCashback: ["Travel", "Cashback"],
};
export const useStore = create<StoreType>((set) => ({
  filters: DEFAULT_FORM_VALUES,
  setFilters: async (filters: Filters) => {
    set({ filters });
  },
  data: [],
  setData: (data: CreditCard[]) => {
    set({ data });
  },
}));

export const getStore = () => useStore.getState();
